"use client";
const e = Object.freeze({
  s12: "0.75rem",
  s14: "0.875rem",
  s16: "1rem",
  s18: "1.125rem",
  s20: "1.25rem",
  s24: "1.5rem",
  s28: "1.75rem",
  s32: "2rem",
  s36: "2.25rem",
  s40: "2.5rem",
  s48: "3rem",
  s56: "3.5rem",
  s64: "4rem",
  s02: "0.125rem",
  s04: "0.25rem",
  s06: "0.375rem",
  s08: "0.5rem"
}), s = Object.keys(e);
export {
  e as SIZES,
  s as SIZE_KEYS
};
